// extracted by mini-css-extract-plugin
export default {"dogContainer":"dog_dogContainer__ADXpE","imageContainer":"dog_imageContainer__yL1-6","textContainer":"dog_textContainer__T0RMk","image":"dog_image__X06Al"};